import React from "react";
import { DashboardConfigTable } from "../../DashboardConfigTable/DashboardConfigTable";

export const Configuration = () => {
    return (
        <DashboardConfigTable/>
    )
}